import * as React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import PropTypes from "prop-types";

const HtmlTooltip = styled(({ className, ...props }) => (
	<Tooltip
		{...props}
		className="hover:cursor-pointer inline-block"
		classes={{ popper: className }}
		placement={props.placement || "bottom"}
	/>
))(({ theme }) => ({
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "#f5f5f9",
		color: "rgba(0, 0, 0, 0.87)",
		maxWidth: 400,
		fontSize: theme.typography.pxToRem(12),
		border: "1px solid #dadde9",
	},
}));

export default function CustomTooltip({ title, description, example, placement, children }) {
	// Ensure a single ReactElement child
	let content = children;
	if (typeof content === "string" || typeof content === "number") {
		content = <span>{content}</span>;
	} else if (Array.isArray(content)) {
		content = <span>{content}</span>;
	}

	return (
		<HtmlTooltip
			arrow
			placement={placement || "bottom"}
			title={
				<div className="flex flex-col gap-1">
					<p className="font-medium text-lg">
						<strong>{title}</strong>
					</p>
					{description && <p className="text-sm">{description}</p>}
					{example && <p className="text-xs italic">Example: {example}</p>}
				</div>
			}
		>
			{content}
		</HtmlTooltip>
	);
}

CustomTooltip.propTypes = {
	title: PropTypes.node.isRequired,
	description: PropTypes.node,
	example: PropTypes.node,
	children: PropTypes.node.isRequired,
	placement: PropTypes.oneOf(["top", "bottom", "left", "right"]),
};
